/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_ab90a1d4"]'><cube-button light active>light</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_ab90a1d4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_ab90a1d4"}
  /** script content **/
  require("./btn-light-active.mpx.js?isComponent&outputPath=components%2Fbtn-light-activeab90a1d4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-light-active.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-light-activeab90a1d4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_ab90a1d4"],
    ctorType: "component",
    outputPath: "components/btn-light-activeab90a1d4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>